import { useContext, useRef, useEffect, useState } from 'react';
import { ThemeContext } from 'styled-components';

function useTheme() {
  const theme = useContext(ThemeContext);
  if (typeof theme === 'undefined') {
    throw new Error('useTheme: Attempting to access undefined context, possibly outside of `ThemeProvider`');
  }
  return theme;
}

const useMount = effect => {
  const mounted = useRef(false);
  useEffect(() => {
    if (!mounted.current) {
      effect();
      mounted.current = true;
    }
  });
};
const useIsMounted = () => {
  const [mounted, setMounted] = useState(false);
  useMount(() => {
    setMounted(true);
  });
  return mounted;
};

export { useMount as a, useIsMounted as b, useTheme as u };
